module.exports = __webpack_public_path__ + "static/media/Al.825c950c.svg";